import { createFcmContext } from 'src/app/shared/contexts/fcm';
import type { LoadedStateData } from 'src/app/shared/utils/async';

export const {
	FcmContext: HomepagePageFcmContext,
	FcmProvider: HomepagePageFcmContextProvider,
	useFcm: useHomepagePageFcm,
	useAsyncFcm: useAsyncHomepagePageFcm,
	prefetchFcm: prefetchHomepagePageFcm,
} = createFcmContext({
	name: 'HomepagePageFcmContext',
	dataProperty: 'pageFcm',
	configs: {},
	prefetch: true,
});

export type HomepagePageFcmState = ReturnType<typeof useAsyncHomepagePageFcm>;
export type HomepagePageFcm = LoadedStateData<HomepagePageFcmState>;
